<template>
  <div>
    <!-- alerta -->
    <Alert
      :alert="alert"
      :type="alertType"
      :title="alertTitle"
      :message="alertMessage"
    />

    <template v-if="skeletonLoader">
      <v-skeleton-loader
        type="table-heading, table-thead, table-tbody@2, table-tfoot"
      >
      </v-skeleton-loader>
    </template>
    <template v-else>
      <!-- tabla -->
      <v-card>
        <v-card-title class="text-h6 text-sm-h5 font-weight-bold primary--text">
          <v-row>
            <v-col 
              cols="12" 
              sm="8"
            >
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    fab
                    small
                    exact
                    color="primary"
                    class="mr-4"
                    v-bind="attrs"
                    v-on="on"
                    @click="regresar"
                  >
                    <v-icon> mdi-arrow-left </v-icon>
                  </v-btn>
                </template>
                <span>Regresar</span>
              </v-tooltip>

              Documentos: {{ competenciaWorldSkills.competencia }}
            </v-col>

            <v-col 
              cols="12"
              sm="4"
              class="d-flex justify-end"
            >
              <template v-if="documentos.length > 0">
                <v-text-field
                  outlined
                  dense
                  append-icon="mdi-magnify"
                  label="Buscar Documento"
                  class="mr-4"
                  hide-details
                  v-model="searchTable"
                >
                </v-text-field>
              </template>

              <v-btn 
                exact 
                color="primary" 
                @click="abrirDialog"
              >
                Registrar
              </v-btn>
            </v-col>
          </v-row>
        </v-card-title>

        <v-data-table 
          fixed-header
          height="calc(100vh - 220px)"
          class="elevation-2"
          :headers="headersTable"
          :items="documentos"
          :search="searchTable"
          :footer-props="{ 'items-per-page-options': [50, 100, -1] }"
        >
          <template v-slot:[`item.acciones`]="{ item }">  
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  color="primary"
                  class="mr-2"
                  v-bind="attrs"
                  v-on="on"
                  @click="descargarDocumento(item.id, item.nombre_documento)"
                >
                mdi-cloud-download
                </v-icon>
              </template>
              <span>Descargar Documento</span>
            </v-tooltip>

            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  color="error"
                  v-bind="attrs"
                  v-on="on"
                  @click="activarAlertaEliminar(item.competencia_id, item.id)"
                >
                  mdi-delete
                </v-icon>
              </template>
              <span>Eliminar</span>
            </v-tooltip>
          </template>

          <template v-slot:top>
            <v-dialog 
              persistent 
              v-model="dialogForm" 
              max-width="520px"
            >
              <v-card :loading="loadingForm">
                <v-card-title class="justify-center">
                  <p class="text-h5 font-weight-bold primary--text">
                    {{ formTitle }}
                  </p>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-row justify="center">
                      <v-col 
                        cols="12" 
                        md="10"
                      >
                        <v-form 
                          ref="form" 
                          v-model="form"
                        >    
                          <v-text-field
                              outlined
                              dense
                              type="text"
                              label="Nombre del documento"
                              maxlength="50"
                              counter
                              v-model="nombreDocumento"
                              :rules="nombreDocumentoReglas"
                          >
                          </v-text-field>

                          <v-file-input
                              outlined
                              dense
                              prepend-icon=""
                              append-icon="mdi-file-pdf-box"
                              accept="application/pdf"
                              label="Documento"
                              truncate-length="100"
                              counter
                              show-size
                              v-model="documento"
                              :rules="documentoReglas"
                          >
                          </v-file-input>
                        </v-form>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn 
                    text 
                    color="error" 
                    @click="cerrarDialog"
                  >
                    Cancelar
                  </v-btn>

                  <template v-if="editedIndex === -1">
                    <v-btn 
                      text 
                      exact 
                      color="primary" 
                      @click="registrar"
                    >
                      Registrar
                    </v-btn>
                  </template>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </template>
        </v-data-table>
      </v-card>  
    </template>
    <v-dialog v-model="dialogDelete" max-width="500px">
      <v-card>
        <v-card-title class="justify-center text-h5">¿Desea eliminar el documento?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn 
            text 
            color="primary" 
            @click="closeDelete"
          >
            Cancelar
          </v-btn>

          <v-btn
            text
            color="error"
            @click="eliminar"
          >
            OK
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
    
<script>
import Alert from '../../../components/admin/Alert.vue';

export default {
  data: () => ({
    skeletonLoader: true,
    searchTable: null,

    alert: false,
    alertType: '',
    alertTitle: '',
    alertMessage: '',

    headersTable: [
      {
        text: "Nombre del documento",
        value: "nombre_documento",
        align: "start",
        class: ["text-subtitle-1", "font-weight-black"],
      },

      {
        text: "Acciones",
        value: "acciones",
        align: "center",
        sortable: false,
        filterable: false,
        class: ["text-subtitle-1", "font-weight-black"],
      }
    ], 

    form: true,
    loadingForm: false,

    dialogForm: false,
    dialogDelete: false,

    temCompetencia_id: null,
    temId_documento_competencia: null,

    nombreDocumento: null,
    nombreDocumentoReglas: [
      (v) => !!v || "Escriba un nombre para el documento"
    ],

    documento: null,
    documentoReglas: [
      (v) => !!v || "Seleccione un documento",
      (v) => !v || v.size <= 10000000 || "El tamaño del documento debe ser menor de 10 MB"
    ],

    editedIndex: -1,
  }),

  components: {
    Alert
  },

  mounted() {
    this.$store.dispatch("gestionarDocumentosCompetencia", this.$route.params.id_competencia);
    this.$store.dispatch("detalleCompetenciaWorldSkills", this.$route.params.id_competencia);
    
    setTimeout(() => {
      this.skeletonLoader = false
    }, 1000);
  },

  computed: {
    documentos() {
      return this.$store.getters.obtenerDocumentosCompetencias
    },

    competenciaWorldSkills() {
      return this.$store.getters.obtenerCompetenciaWorldSkills
    },

    formTitle() {
      return this.editedIndex === -1 ? "Registrar Documento" : "Actualizar Documento";
    }
  },

  watch: {
    dialog(val) {
      val || this.cerrarDialog();
    },

    dialogDelete(val) {
      val || this.closeDelete();
    }
  },

  methods: {
    abrirDialog() {
      this.dialogForm = true;
    },

    deleteItem(item) {
      this.editedIndex = this.asociarProgramasFpi.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    deleteItemConfirm() {
      this.asociarProgramasFpi.splice(this.editedIndex, 1);
      this.closeDelete();
    },

    cerrarDialog() {
      this.dialogForm = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
      this.$refs.form.reset();
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    registrar() {
      if (this.$refs.form.validate()) {
        const documento = new FormData();
        documento.set("nombre_documento", this.nombreDocumento[0].toUpperCase() + this.nombreDocumento.toLowerCase().substring(1));
        documento.set("documentos",       this.documento);
        documento.set("competencia_id",   this.$route.params.id_competencia);

        this.$store.dispatch("registrarDocumentoCompetencia", documento)
        .then((response) => {
          if(response.status == "success") {
            this.loadingForm = false;
            this.cerrarDialog();

            let message       = response.message.split(',')
            this.alertType    = "success--text";
            this.alertTitle   = message[0];
            this.alertMessage = message[1];
            this.alert        = true;

            this.skeletonLoader = true

            this.$store.dispatch("gestionarDocumentosCompetencia", this.$route.params.id_competencia);

            setTimeout(() => {
              this.alert = false;
              this.skeletonLoader = false
            }, 1000);
          } 
          else {
            this.loadingForm  = false
            this.alertType    = "error--text";
            this.alertTitle   = "Error";

            for (const error in response.message) {
              this.alertMessage = response.message[error][0]
            }

            this.alert = true;

            setTimeout(() => {
              this.alert = false
            }, 3000)
          }
        })
        .catch(() => {});
      }
    },

    activarAlertaEliminar(categoria_id, id_documento) {
      this.temCompetencia_id = categoria_id;
      this.temId_documento_competencia = id_documento;
      this.dialogDelete = true;
    },

    eliminar() {
      this.dialogDelete = false;
      const documento = {
        competencia_id: this.temCompetencia_id,
        id_documento_competencia: this.temId_documento_competencia,
      };
      
      this.$store.dispatch("eliminarDocumentoCompetencia", documento)
        .then((response) => {
          if (response.status == "success") {

            let message       = response.message.split(',')
            this.alertType    = "success--text";
            this.alertTitle   = message[0];
            this.alertMessage = message[1];
            this.alert        = true;

            this.skeletonLoader = true

            this.$store.dispatch("gestionarDocumentosCompetencia", this.$route.params.id_competencia);
            setTimeout(() => {
              this.alert = false;
              this.skeletonLoader = false
            }, 1000);
          } 
          else {
            this.loadingForm  = false
            this.alertType    = "error--text";
            this.alertTitle   = "Error";

            for (const error in response.message) {
              this.alertMessage = response.message[error][0]
            }

            this.alert = true;

            setTimeout(() => {
              this.alert = false
            }, 3000)
          }
        })
        .catch(() => {});
    },

    descargarDocumento(idDocumento, nombreDocumento) {
      this.$store.dispatch("descargarDocumentoCompetencia", idDocumento)
      .then((response) => {
        const urlReporte = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href= urlReporte
        link.setAttribute('download', `${nombreDocumento}.pdf`)
        document.body.appendChild(link)
        link.click();
      })
      .catch(() => {
        this.alertType    = "error--text";
        this.alertTitle   = "Error";
        this.alertMessage = `El documento ${nombreDocumento} no tiene documento registrado`;
        this.alert        = true;
      })

      setTimeout(() => {
        this.alert = false;
      }, 3000);
    },

    regresar() {
      this.$router.back()
    },
  }
};
</script>
    